module.exports = __webpack_public_path__ + "img/cardslider.007a78e6.jpg";